var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserServiceOidcGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860 348h86v79h-86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860 348h86v79h-86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860 348h86v79h-86z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M95.897 89.397c-18.199 0-32.948-14.75-32.948-32.949 0-18.198 14.75-32.948 32.948-32.948 18.199 0 32.949 14.75 32.949 32.948 0 18.2-14.75 32.949-32.949 32.949",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#b5c7cd",
      fillOpacity: 1,
      strokeWidth: 1.64743,
      strokeMiterlimit: 10
    },
    d: "M95.896 102.576c-47.646 0-65.69 40.235-65.69 40.235L30 168.473h74.885a46.625 32.11 0 0 1-10.633-20.33 46.625 32.11 0 0 1 42.268-31.836V114.5c-10.09-6.687-23.449-11.924-40.624-11.924z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-760 -251)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M899.035 354.309v72.643l13.012-6.078V348z",
    fill: "#f8941c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m944.097 375.618 1.796 18.509-25.163-5.434",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.011 399.304c0-9.15 10.046-16.857 23.74-19.209v-8.203C875.806 374.405 860 385.722 860 399.304c0 14.073 16.966 25.712 39.035 27.649v-8.097c-14.848-1.847-26.024-9.898-26.024-19.552m41.32-27.408v8.199c5.448.936 10.321 2.715 14.212 5.101l9.2-5.643c-6.27-3.847-14.363-6.572-23.413-7.657",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.035 354.309v72.643l13.012-6.078V348z",
    fill: "#f8941c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m944.097 375.618 1.796 18.509-25.163-5.434",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.011 399.304c0-9.15 10.046-16.857 23.74-19.209v-8.203C875.806 374.405 860 385.722 860 399.304c0 14.073 16.966 25.712 39.035 27.649v-8.097c-14.848-1.847-26.024-9.898-26.024-19.552m41.32-27.408v8.199c5.448.936 10.321 2.715 14.212 5.101l9.2-5.643c-6.27-3.847-14.363-6.572-23.413-7.657",
    fill: "#bcbec0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserServiceOidcGeneric);
export default __webpack_public_path__ + "static/media/userServiceOidcGeneric.e52a405633ac621351217ced69ccf00f.svg";
export { ForwardRef as ReactComponent };